import './App.css';
import Footer from './Components/Footer';
import Header from './Components/Header'
import Slider from './Components/Slider';
import Films from './Components/Films';
import Contact from './Components/Contact';
import About from './Components/About';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Test from './Components/Test';
import Details from './Components/details';
import { useState } from "react";
import Categories from './Components/Categories';
import Buy from './Components/Buy';

function App() {

const [cart, setCart] = useState([]);

const addToCart = (film) => {
  const exist = cart.find((item) => item.id === film.id);
  
  if (exist) {
    alert("Film already in cart");
    return;
  }

  setCart([...cart, film]);
};

const removeFromCart = (id) => {
  const newCart = cart.filter((item) => item.id !== id);
  setCart(newCart);
};

  return (
    <BrowserRouter>

      <Header cart={cart} removeFromCart={removeFromCart}/>
      
      

      <Routes>
        <Route path='*' element={<> <Slider /> <About /> <Films/> <Contact/> <Categories/></>} />
        <Route path='home' element={<> <Slider /><About /><Films/><Contact/> </> } />
        <Route path='joker' element={<Test></Test>} />
        <Route path='films' element={<Films />} />
        <Route path='about' element={<About />} />
        <Route path="/details/:id" element={<Details addToCart={addToCart} cart={cart}/>} />
        <Route path='categories' element={<Categories />} />
        <Route path='contact' element={<Contact />} />
        <Route path='buy' element={<Buy cart={cart} removeFromCart={removeFromCart} />}></Route>
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;